import { useQuery } from '@tanstack/react-query';
import api from '../lib/api';

export const useContactMessages = (page = 1, perPage = 15) => {
    const { data, isLoading, error } = useQuery({
        queryKey: ['companyContactMessages', page, perPage],
        queryFn: () =>
            api.get('/company/contacts', { params: { page } }).then(res => res.data),
        keepPreviousData: true,
    });

    // Normalize the API response structure
    // API returns: { success: true, data: { current_page, data: [...], per_page, total, last_page, ... } }
    const responseData = data?.data || {};
    const messages = responseData.data || [];
    const pagination = {
        current_page: responseData.current_page || 1,
        last_page: responseData.last_page || 1,
        per_page: responseData.per_page || perPage,
        total: responseData.total || 0,
    };

    return {
        messages,
        pagination,
        isLoading,
        error,
    };
};

